import { takeLatest, call, put } from 'redux-saga/effects';
import dataApi from '../../apis/dataApi';
import * as constants from './constants';
import * as actions from './actions';
import handleError from '../handleError';

export function* fetchIngredients() {
  try {
    const response = yield call(dataApi.fetchIngredients);
    yield put(actions.fetchIngredientsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchIngredientsFail',
      put(actions.fetchIngredientsFail(error))
    );
  }
}

export function* fetchIngredient(action) {
  try {
    const itemCode = action.payload;
    const response = yield call(dataApi.fetchIngredient, itemCode);
    yield put(actions.fetchIngredientDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchIngredientFail',
      put(actions.fetchIngredientFail(error))
    );
  }
}

// export function* fetchMarketIngredient(action) {
//   try {
//     const marketCode = action.payload;
//     const response = yield call(dataApi.fetchMarketIngredients, marketCode);
//     yield put(actions.fetchIngredientDone(response.data));
//   } catch (error) {
//     yield call(
//       handleError,
//       error,
//       'notify.fetchIngredientFail',
//       put(actions.fetchIngredientFail(error))
//     );
//   }
// }

export function* fetchGlobalIngredients() {
  try {
    const response = yield call(dataApi.fetchGlobalIngredients);
    yield put(actions.fetchGlobalIngredientsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchGlobalIngredientsFail',
      put(actions.fetchGlobalIngredientsFail(error))
    );
  }
}

export function* fetchExcludedIngredients() {
  try {
    const response = yield call(dataApi.fetchExcludedIngredients);
    yield put(actions.fetchExcludedIngredientsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchExcludedIngredientsFail',
      put(actions.fetchExcludedIngredientsFail(error))
    );
  }
}

export function* excludeIngredients(action) {
  try {
    const itemCodes = action.payload;
    const response = yield call(dataApi.excludeIngredients, itemCodes);
    yield put(actions.excludeIngredientsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.excludeIngredientsFail',
      put(actions.excludeIngredientsFail(error))
    );
  }
}

export function* includeIngredients(action) {
  try {
    const itemCodes = action.payload;
    const response = yield call(dataApi.includeIngredients, itemCodes);
    yield put(actions.includeIngredientsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.includeIngredientsFail',
      put(actions.includeIngredientsFail(error))
    );
  }
}

export default [
  takeLatest(constants.FETCH_INGREDIENTS, fetchIngredients),
  // takeLatest(constants.FETCH_MARKET_INGREDIENTS, fetchMarketIngredient),
  takeLatest(constants.FETCH_INGREDIENT, fetchIngredient),
  takeLatest(constants.FETCH_GLOBAL_INGREDIENTS, fetchGlobalIngredients),
  takeLatest(constants.FETCH_EXCLUDED_INGREDIENTS, fetchExcludedIngredients),
  takeLatest(constants.EXCLUDE_INGREDIENTS, excludeIngredients),
  takeLatest(constants.INCLUDE_INGREDIENTS, includeIngredients)
];
